import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DobryPradFormData } from '../models/dobry-prad-form-data';

export class DobryPradForm extends FormGroup {
  constructor(phoneNumber: string = '') {
    super({
      contactConsent: new FormControl(false, [Validators.requiredTrue]),
      passCurrentAgreementTermsConsent: new FormControl(false, []),
      phoneNumber: new FormControl(phoneNumber, [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(9),
      ]),
    });
  }

  get phoneNumber(): FormControl {
    return this.get('phoneNumber') as FormControl;
  }

  get contactConsent(): FormControl {
    return this.get('contactConsent') as FormControl;
  }

  get passCurrentAgreementTermsConsent(): FormControl {
    return this.get('passCurrentAgreementTermsConsent') as FormControl;
  }

  public getFinalData(): DobryPradFormData {
    return new DobryPradFormData(this.contactConsent.value, this.passCurrentAgreementTermsConsent.value, this.phoneNumber.value);
  }
}
